var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMisc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.353 11.6475C10.5682 9.28202 8.31169 6.46507 6.61603 3.18311C6.2769 2.52942 5.4878 2.28006 4.84867 2.6305C4.21606 2.98093 3.97471 3.79638 4.31384 4.45682C6.17906 8.04877 8.64432 11.1353 11.6965 13.7299C12.2508 14.2016 13.0791 14.1207 13.5356 13.5479C13.9921 12.9683 13.9073 12.1192 13.353 11.6475Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8698 2.43485C12.0133 5.15746 12.1438 7.88006 12.3068 10.6027C12.3525 11.344 12.972 11.9101 13.6894 11.8629C14.4068 11.8157 14.9546 11.1755 14.909 10.4342C14.7459 7.71832 14.6155 5.00247 14.472 2.27986C14.4329 1.54058 13.8133 0.97112 13.0959 1.0129C12.3785 1.05468 11.8242 1.69152 11.8698 2.43485Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.552 2.9879C19.8824 5.5892 17.9912 7.9883 16.0868 10.4144C15.6303 10.994 15.715 11.8431 16.2759 12.3081C16.8368 12.7799 17.6586 12.6922 18.1086 12.1127C20.0651 9.62593 22.0086 7.15265 23.7303 4.47722C24.1281 3.85722 23.9585 3.02159 23.3585 2.61051C22.765 2.19942 21.9498 2.3679 21.552 2.9879Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0174 12.6581C23.4913 12.867 18.6848 12.8738 14.1587 12.5773C13.4413 12.5368 12.8217 13.0962 12.7761 13.8442C12.7304 14.5855 13.2783 15.2257 13.9957 15.2729C18.6131 15.5694 23.5174 15.5627 28.1348 15.3538C28.8522 15.3201 29.413 14.6866 29.3804 13.9453C29.3478 13.204 28.7348 12.6244 28.0174 12.6581Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6949 13.5143C14.4862 17.0456 17.3754 20.5096 19.9645 24.2026C20.3884 24.8024 21.2037 24.9371 21.7906 24.4991C22.3711 24.061 22.5015 23.2186 22.0775 22.6188C19.4558 18.8854 16.5341 15.381 13.7102 11.8093C13.2537 11.2365 12.4319 11.1489 11.8775 11.6206C11.3167 12.0923 11.2384 12.9415 11.6949 13.5143Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5403 14.5389C13.2707 18.2185 13.4729 21.7363 13.525 25.463C13.5316 26.2044 14.1251 26.7974 14.8425 26.7906C15.5664 26.7772 16.1403 26.1706 16.1272 25.4226C16.075 21.5206 15.8599 17.8478 15.0968 13.993C14.9468 13.2652 14.262 12.7934 13.5512 12.9484C12.8468 13.0967 12.3903 13.8111 12.5403 14.5389Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6561 14.2425C10.543 18.6095 9.45388 23.4617 7.19083 27.7343C6.84518 28.3813 7.07992 29.2034 7.71253 29.5606C8.34513 29.9177 9.13432 29.6751 9.47997 29.0282C11.7561 24.7286 12.8582 19.8495 14.9908 15.4488C15.3104 14.7817 15.0495 13.973 14.4104 13.636C13.7647 13.3058 12.9821 13.5754 12.6561 14.2425Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8209 13.2508C9.61439 14.019 5.41439 14.3694 1.18178 14.8884C0.464392 14.976 -0.0443034 15.6432 0.0404792 16.3845C0.125262 17.1258 0.770974 17.6514 1.48837 17.5638C5.76663 17.0449 10.0188 16.681 14.2775 15.906C14.9818 15.7712 15.4579 15.0703 15.334 14.3425C15.2036 13.6079 14.5318 13.116 13.8209 13.2508Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7461 11.2025C15.8787 11.162 15.057 11.1014 14.2092 10.9733C13.4918 10.8655 12.8331 11.3777 12.7287 12.1122C12.6244 12.8468 13.12 13.5342 13.8309 13.642C14.77 13.7836 15.6765 13.8509 16.6287 13.8914C17.3461 13.9251 17.9591 13.3522 17.9852 12.6042C18.0178 11.8629 17.4635 11.2362 16.7461 11.2025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMisc);
export default __webpack_public_path__ + "static/media/icon-misc.a5ea588943f2df91ccf54e57d79d2f1e.svg";
export { ForwardRef as ReactComponent };